var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.team.uses_veeva_vault && _vm.presentation.vaultConfiguration)?_c('div',{staticClass:"d-flex align-middle"},[_c('img',{staticClass:"mr-1",staticStyle:{"height":"20px","width":"auto"},attrs:{"src":"/v2/images/veeva/veeva-vault-1.png","alt":"Imported from Veeva Vault"}}),_vm._v("\n  "+_vm._s(_vm.presentation.external_id)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }